import React, { useContext } from "react";
import CSAutocomplete from "./autocomplete";
import AvailableIndices from "./search-indices";
import { getAlgoliaResults } from "@algolia/autocomplete-js";
import { connectSearchBox } from "react-instantsearch-dom";
import { MobileContext } from "base/util/mobile-context";
import { createConnector } from 'react-instantsearch-dom';
import { connectMenu } from "react-instantsearch-core";
import Dropdown from "base/util/dropdown";
import ShowIf from "base/util/show-if";
import { SearchContext } from "./search-context";
const searchBoxConnector = createConnector({
    displayName: 'CSSearchBoxContainer',
    getProvidedProps(_props, searchState) {
        const query = searchState.query || '';
        return { query };
    },
    refine(_props, searchState, newState) {
        return Object.assign(Object.assign({}, searchState), { query: newState.query });
    },
});
const categoryMenuConnector = createConnector({
    displayName: 'CSCategoryMenu',
    getProvidedProps(_props, searchState) {
        var _a;
        const category = ((_a = searchState.menu) === null || _a === void 0 ? void 0 : _a.categories) || '';
        return { currentCategory: category };
    },
    refine(_props, searchState, newCategory) {
        return Object.assign(Object.assign({}, searchState), { menu: { categories: newCategory || '' } });
    },
});
const CustomMenuSelect = ({ currentCategory, refine }) => {
    const getItemId = React.useCallback((_item, index) => {
        return index.toString();
    }, []);
    const getItemTitle = React.useCallback((item) => {
        return (item === null || item === void 0 ? void 0 : item.label) || '';
    }, []);
    const onSelectItem = React.useCallback((item) => {
        refine((item === null || item === void 0 ? void 0 : item.value) || '');
    }, []);
    const searchContext = useContext(SearchContext);
    const categories = React.useMemo(() => {
        return searchContext.categoryFacets.map(facet => (Object.assign(Object.assign({}, facet), { value: facet.value === currentCategory ? '' : facet.value, isRefined: facet.value === currentCategory })));
    }, [searchContext, currentCategory]);
    const usedItems = React.useMemo(() => {
        return [{
                count: 0,
                isRefined: currentCategory === '',
                label: larry.search.seeAll,
                value: '',
            }, ...categories];
    }, [categories]);
    const selectedItem = categories.find(category => category.value === '') || usedItems[0];
    return (React.createElement(React.Fragment, null,
        React.createElement(Dropdown, { getItemId: getItemId, getItemTitle: getItemTitle, selectedItem: selectedItem, onSelectItem: onSelectItem, items: usedItems })));
};
const CustomMenu = ({ currentCategory, refine }) => {
    const getItemId = React.useCallback((_item, index) => {
        return index.toString();
    }, []);
    const getItemTitle = React.useCallback((item) => {
        return (item === null || item === void 0 ? void 0 : item.label) || '';
    }, []);
    const onSelectItem = React.useCallback((item) => {
        refine((item === null || item === void 0 ? void 0 : item.value) || '');
    }, []);
    const searchContext = useContext(SearchContext);
    const categories = React.useMemo(() => {
        return searchContext.categoryFacets.map(facet => (Object.assign(Object.assign({}, facet), { value: facet.value === currentCategory ? '' : facet.value, isRefined: facet.value === currentCategory })));
    }, [searchContext, currentCategory]);
    const listItems = categories.map((item, index) => {
        const classes = ['ais-Menu-item'];
        if (item.isRefined)
            classes.push('ais-Menu-item--selected');
        return (React.createElement("li", { key: getItemId(item, index), className: classes.join(' ') },
            React.createElement("a", { className: "ais-Menu-link", href: "#", onClick: (event) => { event.preventDefault(); onSelectItem(item); } },
                React.createElement("span", { className: "ais-Menu-label" }, getItemTitle(item)))));
    });
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "ais-Menu" },
            React.createElement("ul", { className: "ais-Menu-list" }, listItems))));
};
const SearchBox = ({ searchClient, query, refine }) => {
    const VirtualSearchBox = React.useMemo(() => connectSearchBox(() => null), []);
    const onSubmit = React.useCallback(({ state }) => {
        refine({
            query: state.query || '',
        });
    }, [refine]);
    const onReset = React.useCallback(() => {
        refine({
            query: '',
        });
    }, [refine]);
    return (React.createElement("div", { className: 'wm-searchBox' },
        React.createElement(VirtualSearchBox, null),
        React.createElement(CSAutocomplete, { openOnFocus: true, placeholder: larry.search.writeQuestion, initialState: { query: query }, onSubmit: onSubmit, onReset: onReset, debug: false, getSources: ({ setQuery, query }) => [
                {
                    sourceId: 'content',
                    onSelect({ itemInputValue }) {
                        setQuery(itemInputValue);
                        refine({
                            query: itemInputValue,
                        });
                    },
                    getItemInputValue({ item }) {
                        return jQuery('<textarea />').html(item.title).text();
                    },
                    getItems() {
                        return getAlgoliaResults({
                            searchClient,
                            queries: [
                                {
                                    indexName: AvailableIndices.post.index,
                                    query,
                                    params: {
                                        hitsPerPage: AvailableIndices.post.hitsPerPage,
                                        filters: 'lang:' + larry.lang
                                    },
                                },
                                {
                                    indexName: AvailableIndices.page.index,
                                    query,
                                    params: {
                                        hitsPerPage: AvailableIndices.page.hitsPerPage,
                                        filters: 'lang:' + larry.lang
                                    },
                                },
                                {
                                    indexName: AvailableIndices.video.index,
                                    query,
                                    params: {
                                        hitsPerPage: AvailableIndices.video.hitsPerPage,
                                        filters: 'lang:' + larry.lang
                                    },
                                },
                            ],
                        });
                    },
                }
            ] })));
};
const VirtualMenu = connectMenu(() => null);
const ConnectedSearchBox = searchBoxConnector(SearchBox);
const ConnectedCustomMenuSelect = categoryMenuConnector(CustomMenuSelect);
const ConnectedCustomMenu = categoryMenuConnector(CustomMenu);
const SearchHeader = ({ searchClient }) => {
    const isMobile = useContext(MobileContext);
    const rootClasses = ['wm-searchHeader'];
    if (isMobile)
        rootClasses.push('-shMobile');
    return (React.createElement("div", { className: rootClasses.join(' ') },
        React.createElement(ConnectedSearchBox, { searchClient: searchClient }),
        React.createElement("div", { className: 'wm-searchCategoryMenu' },
            React.createElement("span", { className: "h4" }, larry.search.chooseTopic),
            React.createElement(VirtualMenu, { attribute: "categories", limit: 8 }),
            React.createElement(ShowIf, { show: isMobile },
                React.createElement(ConnectedCustomMenuSelect, null)),
            React.createElement(ShowIf, { show: !isMobile },
                React.createElement(ConnectedCustomMenu, null)))));
};
export default SearchHeader;
